import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useQuery } from 'react-query'

import { Transcription } from 'types'

type Data = Transcription

const fetchTranscription = async (workspaceId: number, id?: number) => {
  if (!id) return
  const res = await sendToApi(`/w/${workspaceId}/transcriptions/${id}`)

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data.transcription
}

const inProgressStatuses = ['pending', 'started']

export const useTranscription = (id?: number) => {
  const workspaceId = useCurrentWorkspaceId()
  const getRefetchInterval = (transcription: Data | undefined) => {
    if (!transcription) return false
    return inProgressStatuses.includes(transcription?.status) ? 1000 : false
  }

  return useQuery<Data, Error>(['transcription', workspaceId, id], () => fetchTranscription(workspaceId, id), {
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!id,
    refetchInterval: (data) => getRefetchInterval(data), // Use function to determine refetch interval
  })
}
